import React, { useState } from "react";
import "./ConfirmationPopup.css"; // Import the CSS file

const ConfirmationPopup = ({ isOpen, onClose, onConfirm }) => {
	const [delLoading, setDelLoading] = useState(false);
	if (!isOpen) return null;

	return (
		<div className="confirmation-overlay">
			<div className="confirmation-container">
				<h2 className="confirmation-title">Confirm Deletion</h2>
				<p className="confirmation-message">
					Are you sure you want to delete this Blog? This action cannot be undone.
				</p>
				<div className="confirmation-buttons">
					<button
						onClick={onClose}
						className="confirmation-button confirmation-button-cancel"
					>
						Cancel
					</button>
					<button
						onClick={() => {
							setDelLoading(true);
							const isLoading = onConfirm();
							setDelLoading(isLoading);
						}}
						className={`confirmation-button confirmation-button-confirm ${delLoading ? "loading" : ""}`}
					>
						{delLoading ? (
							<div className="confirmation-dot-container">
								<span className="confirmation-dot"></span>
								<span className="confirmation-dot"></span>
								<span className="confirmation-dot"></span>
							</div>
						) : (
							"Ok"
						)}
					</button>
				</div>
			</div>
		</div>
	);
};

export default ConfirmationPopup;
